/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], function() {


	class DashboardFeatures {
		constructor() {
			this.features = {};
		}

		addFeature(name, feature) {
			this.features[name] = feature;
		}

		onContentSelection(idList) {
			Object.values(this.features).forEach(feature => {
				if (feature.onContentSelection) {
					feature.onContentSelection(idList);
				}
			});
		}
	}

	return DashboardFeatures;
});
